module.exports = __webpack_public_path__ + "img/5.c58d038c.png";